import { AppBarConfirmButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useDispatch } from "react-redux";
import { RecognitionStatus } from "../../domain/RecognitionStatus";
import { withdrawApplication } from "../../redux/actions";
import {
  NonNullableOrganisationState,
  NonNullableRecognitionApplicationState,
} from "../../redux/state";
import { OrganisationAppBar } from "../OrganisationAppBar";
import { ApproveButtonAndDialog } from "./dialogs/ApproveButtonAndDialog";
import { RejectButtonAndDialog } from "./dialogs/RejectButtonAndDialog";

type ApplicationAppBarProps = {
  orgState: NonNullableOrganisationState;
  applicationState: NonNullableRecognitionApplicationState;
  tabName: "Application" | "Review" | "Scopes" | "Organisation Details";
  canEdit: boolean;
};

export const ApplicationAppBar: React.FC<ApplicationAppBarProps> = ({
  orgState,
  applicationState,
  tabName,
  children,
  canEdit,
}) => {
  const dispatch = useDispatch();
  const { application } = applicationState;
  const { org } = orgState;
  const coreBreadCrumbs = [
    { label: org.name, to: `${org.itemId}` },
    { label: "Recognition", to: `${org.itemId}/recognition` },
    {
      label: `Application ${application.applicationNumber}  (${
        RecognitionStatus[application.status]
      })`,
      to: `${org.itemId}/recognition/applications/${application.id}`,
    },
  ];

  return (
    <OrganisationAppBar
      breadcrumbs={
        tabName === "Application"
          ? coreBreadCrumbs
          : [...coreBreadCrumbs, { label: tabName }]
      }
    >
      <>
        {application.status === RecognitionStatus.Pending && canEdit ? (
          <>
            <ApproveButtonAndDialog
              applicationId={application.id}
              orgId={org.id}
            />

            <RejectButtonAndDialog
              applicationId={application.id}
              orgId={org.id}
            />

            <AppBarConfirmButton
              text="Withdraw"
              data-test="withdraw-button"
              tooltip="Withdraw this Application?"
              onClick={() =>
                dispatch(withdrawApplication(org.id, application.id))
              }
            >
              Are you sure you wish to <strong>Withdraw</strong> this
              application?
            </AppBarConfirmButton>
          </>
        ) : null}
        {children}
      </>
    </OrganisationAppBar>
  );
};
